export function ActionBar({ onBack, onNext, showBack, showNext, disableNext, currentStep, isSubmitting }) {
  return (
    <div className="fixed bottom-0 w-full bg-white border-t border-gray-200 p-4">
      <div className="max-w-7xl mx-auto flex justify-between">
        {showBack && (
          <button
            onClick={onBack}
            disabled={isSubmitting}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Back
          </button>
        )}
        
        <button
          onClick={onNext}
          disabled={disableNext || isSubmitting}
          className="px-4 py-2 bg-[#556B2F] text-white rounded hover:bg-[#4c612a] disabled:opacity-50"
        >
          {isSubmitting ? 'Saving...' : currentStep === 3 ? 'Create Event' : 'Next'}
        </button>
      </div>
    </div>
  )
} 